export default __webpack_public_path__ + "static/media/comp.267d2c25.jpg";